import React from 'react';
import DailyFunctional from './components/daily-report-list-functional';
import './daily-report.scss';

const DailyReport = () => {
	return <DailyFunctional />;
};

export default DailyReport;
